import _ from 'lodash';
import Cognito from '../../../../global/js/cognito';
import {utils} from '../../../../global/js/utils';
import {VerifyAccountModal} from '../../verifyAccountModal/js/verifyAccountModal';
export class ForgotPasswordModal {
	constructor() {
		// Load template
		this.template = $('#ForgotPasswordModal').html();
		this.email = '';
		// Initialize User Pool
		this.userPool = Cognito.getUserPool({
			UserPoolId: window.cognitoUserPoolId,
			ClientId: window.cognitoAppClientId,
		});

		this.verifyModal = new VerifyAccountModal({
			onVerified: ()=> {
				this.onVerified();
			},
		});

		this.userData = null;
		this.cognitoUser = null;
		this.$modal = null;
		this.$serverError = null;
		this.$frmStep1 = null;
		this.$frmStep2 = null;
		this.$sendCode = null;
	}

	init() {
		this.open();
		this.addEventHandler();
	}

	open() {
		this.$modal = $('[data-role="forgot-password-modal"]');
		if (this.$modal.length) {
			this.$modal.removeClass('hidden');
		} else {
			$('body').append(this.template);
			this.$modal = $('[data-role="forgot-password-modal"]');
			setTimeout(()=> {
				this.$modal.removeClass('hidden');
			}, 300);
		}
		this.$serverError = this.$modal.find('.server-error');
		this.$frmStep1 = this.$modal.find('.step-1');
		this.$frmStep2 = this.$modal.find('.step-2');
		this.$sendCode = this.$modal.find('.btn-send-code');
	}

	close() {
		if (this.$modal && this.$modal.length) {
			this.$modal.addClass('hidden');

			// Reset style
			this.$modal.find('.form-group').removeClass('error');
			this.$modal.find('.step-1').removeClass('d-none');
			this.$modal.find('.step-2').addClass('d-none');
			this.$modal.find('input').val('');
			this.$modal.find('.error').html('');
			this.$serverError.html('');
			// Reset data
			this.userData = null;
			this.cognitoUser = null;
		}
	}


	addEventHandler() {
		if (!this.$modal || !this.$modal.length) return;

		const $btnReset = this.$modal.find('.btn-reset');

		this.$modal
			.off('click.close')
			.on('click.close', '.popup-close', (e)=> {
				e.preventDefault();
				this.close();
			});

		this.$modal
			.off('click.send')
			.on('click.send', '.btn-send-code', (e)=> {
				e.preventDefault();
				const $email = this.$modal.find('#email');
				const $emailError = $email.siblings('.error');
				const $emailFormGrp = $email.closest('.form-group');
				const email = $email.val();
				if (utils.isEmail(email)) {
					// Remove error
					$emailError.html('');
					$emailFormGrp.removeClass('error');

					// Request send a verify code
					this.userData = Cognito.createUserData(email, this.userPool);
					this.cognitoUser = Cognito.getCognitoUser(this.userData);

					this.forgotPassword()
						.then(
							(data)=> {
								this.$serverError.html('');
								// Move to next step
								this.$frmStep1.addClass('d-none');
								this.$frmStep2.removeClass('d-none');
							},
							(err)=> {
								this.forgotPasswordErrorHandler(err);
							});
				} else {
					$emailError.html('<span>Email is invalid.</span>');
					$emailFormGrp.addClass('error');
				}
			});

		this.$modal
			.off('click.sendagain')
			.on('click.sendagain', '.btn-send-again', (e)=> {
				e.preventDefault();
				this.forgotPassword()
					.then(
						(data)=> {
							this.$serverError.html('');
						},
						(err)=> {
							this.forgotPasswordErrorHandler(err);
						});
			});

		this.$modal
			.off('click.reset')
			.on('click.reset', '.btn-reset', (e)=> {
				e.preventDefault();
				if (this.cognitoUser) {
					const $code = this.$modal.find('#code');
					const $password = this.$modal.find('#password');
					const $tips = this.$modal.find('.form-tip');

					const verificationCode = $code.val();
					const newPassword = $password.val();
					$btnReset.prop('disabled', true);
					this.confirmPassword(verificationCode, newPassword)
						.then(()=> {
							$tips.addClass('success');
							this.close();
						}, (err)=> {
							this.$serverError.html(`<span>${err.message}</span>`);
							$tips.addClass('error');
						})
						.finally(()=> {
							$btnReset.prop('disabled', false);
						});
				}
			});
	}

	forgotPassword() {
		return new Promise((resolve, reject)=> {
			if (!this.cognitoUser) reject({message: 'Cannot get user.'});
			this.cognitoUser.forgotPassword({
				onSuccess: function(data) {
					resolve(data);
				},
				onFailure: function(err) {
					reject(err);
				},
			});
		});
	}

	forgotPasswordErrorHandler(err) {
		this.$serverError.html(`<span>${err.message}</span>`);
		if ('InvalidParameterException' === err.code) {
			this.verifyModal.init();
		} else {
			this.$sendCode.prop('disabled', true);
		}
	}

	confirmPassword(code, password) {
		return new Promise((resolve, reject)=> {
			if (!this.cognitoUser) reject({message: 'Cannot get user.'});
			this.cognitoUser.confirmPassword(code, password, {
				onSuccess(response) {
					resolve(response);
				},
				onFailure(err) {
					reject(err);
				},
			});
		});
	}

	onVerified() {
		this.$serverError.html('');
		this.$sendCode.prop('disabled', true);
		this.forgotPassword()
			.then(
				(data)=> {
					// Move to next step
					this.$frmStep1.addClass('d-none');
					this.$frmStep2.removeClass('d-none');
					this.$sendCode.prop('disabled', false);
				},
				(err)=> {
					this.forgotPasswordErrorHandler(err);
				});
	}
}
